import React from 'react'
import { TablePagination } from '@mui/material'
import { DATA_TABLE_ROWS_PER_PAGE_OPTIONS } from '../hooks/useDataTableRowsPerPage'

export const DataTablePagination = ({
    count,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
}: {
    count: number
    page: number
    rowsPerPage: number
    onPageChange: (page: number) => void
    onRowsPerPageChange: (rowsPerPage: number) => void
}) => (
    <TablePagination
        component="div"
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={DATA_TABLE_ROWS_PER_PAGE_OPTIONS}
        onPageChange={(_event, nextPage) => onPageChange(nextPage)}
        onRowsPerPageChange={(event) => onRowsPerPageChange(+event.target.value)}
        sx={{
            color: 'figma.grayscale.textHier2',
            '.MuiTablePagination-spacer': { display: 'none' },
            '.MuiTablePagination-toolbar': { pl: 0 },
            '.MuiTablePagination-selectIcon': { color: 'figma.grayscale.tier2' },
            '.MuiTablePagination-actions .MuiIconButton-root': {
                color: 'figma.grayscale.tier2',
                '&:hover': { color: 'figma.primary' },
                '&.Mui-disabled': { color: 'figma.grayscale.tier4' },
            },
        }}
    />
)

export default DataTablePagination
